import { TabsContent } from "@/components/ui/tabs";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import useAuth from "@/hooks/useAuth";


function Shift({ staffSchedules }) {

  const user = useAuth()
  console.log(user)

  return (
    <TabsContent value="shift">
      <Card className="bg-cblack4 mt-5">
        <CardHeader className="bg-[#121212] ">
          <div className="flex w-full justify-between text-center items-center  text-cwhite2">
            <div className="text-center flex justify-center items-center w-full">
              <Label>Weekly Working Day</Label>
            </div>
            <div className="text-center flex justify-center items-center w-full">
              <Label>Monthly Hours</Label>
            </div>
            <div className="text-center flex justify-center items-center w-full">
              <Label>Time Sheet</Label>
            </div>
            {/* <div className="text-center flex justify-center items-center w-full">
              <Label>Action</Label>
            </div> */}
          </div>
        </CardHeader>
        <CardContent>
          <div className="flex  w-full mt-3 text-cwhite3">
            <div className="text-center flex justify-center w-full">
              <Label className>
                {staffSchedules?.working_days || "0"} days
              </Label>
            </div>
            <div className="text-center flex justify-center w-full">
              <Label>
                {Number(staffSchedules?.total_working_hours || 0).toFixed(2)} H
              </Label>
            </div>
            <div className="text-center flex-col -mt-2 justify-center w-full">
              <Label className="text-cgreen">
                {staffSchedules?.shift_schedule?.length || "0"} shifts
              </Label>
              <div className="flex flex-col gap-2 ">
                {staffSchedules?.shift_schedule &&
                staffSchedules?.shift_schedule?.length > 0 ? (
                  staffSchedules?.shift_schedule?.map((item, val) => (
                    <div
                      key={val}
                      className="text-cwhite2 bg-cblack7 rounded border border-neutral-500 p-2 mt-2"
                    >
                      <p className="text-sm">{item?.day || "0"}</p>
                      <p className="text-sm">
                        {item?.start_time} - {item?.end_time}
                      </p>
                    </div>
                  ))
                ) : (
                  <p> Shift not available </p>
                )}
              </div>
            </div>
            {/* <div className="text-center flex justify-center  w-full">
              <Label className="text-cyellow">View Details</Label>
            </div> */}
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  );
}

export default Shift;
